import { languages } from 'i18n'
import uniqueId from 'lodash/uniqueId'
import Raven from 'raven-js'
import config from "./config"
import { CUSTOM_SUPPORT_TYPES, EMBEDDED_INTERVIEW_PATH, IFRAME_VIEW_PATH } from 'app-constants'

export const FETCHING_SET = 'FETCHING_SET'
export const FILE_ADD = 'FILE_ADD'
export const FILE_REMOVE = 'FILE_REMOVE'
export const FILES_REMOVE = 'FILES_REMOVE'
export const LANGUAGE_SET = 'LANGUAGE_SET'
export const NAVIGATION_MENU_TOGGLE = 'NAVIGATION_MENU_TOGGLE'
export const MESSAGE_ADD = 'MESSAGE_ADD'
export const MESSAGE_REMOVE = 'MESSAGE_REMOVE'
export const MODAL_TOGGLE = 'MODAL_TOGGLE'
export const SORT = 'SORT'
export const PAGINATE = 'PAGINATE'
export const SORT_RESET = 'SORT_RESET'
export const FILTER = 'FILTER'
export const VIDEOPLAYER_UPDATE = 'VIDEOPLAYER_UPDATE'
export const CHANGE_GLOBAL_RECORDER = 'CHANGE_GLOBAL_RECORDER'
export const FAVORITE_VIDEOS_UPDATE = 'FAVORITE_VIDEOS_UPDATE'
export const ERROR_ADD = 'ERROR_ADD'
export const TOGGLE_EMBEDDED = 'TOGGLE_EMBEDDED'
export const SET_SHOW_INTERCOM = 'SET_SHOW_INTERCOM'
export const SET_ACTION_BAR_HEIGHT = 'SET_ACTION_BAR_HEIGHT'

export const setActionBarHeight = payload => ({
  type: SET_ACTION_BAR_HEIGHT,
  payload,
})


export const setShowIntercom = company => (dispatch, getState) => {
  const {
    global: { showIntercom }
  } = getState()
  let show = false
  const pathname = window.location.pathname
  const isIframeView = pathname && (pathname.includes(IFRAME_VIEW_PATH) || pathname.includes(EMBEDDED_INTERVIEW_PATH))

  if (company) {
    const customSupport = company && company.customSupport
    const customTypesArray = Object.values(CUSTOM_SUPPORT_TYPES)
    const noCompanyOrCustomSupport = !!(
      !customSupport ||
      !customSupport.enabled ||
      !customTypesArray.includes(customSupport.type) ||
      !customSupport.value
    )

    show = noCompanyOrCustomSupport && !isIframeView
  } else {
    show = !isIframeView
  }

  if (show !== showIntercom) {
    dispatch({
      type: SET_SHOW_INTERCOM,
      payload: show,
    })
  }
}

export const setLanguage = language => ({ type: LANGUAGE_SET, language })

export const toggleNavigationMenu = navigationMenu => ({ type: NAVIGATION_MENU_TOGGLE, navigationMenu })

export const toggleModal = modal => ({ type: MODAL_TOGGLE, modal })

export const updateVideoPlayer = videoPlayer => ({ type: VIDEOPLAYER_UPDATE, videoPlayer })

export const changeGlobalRecorder = recorder => ({ type: CHANGE_GLOBAL_RECORDER, recorder })

export const filter = (name, value) => ({ type: FILTER, name, value })

export const addFile = (key, url) => ({ type: FILE_ADD, key, url })

export const removeFile = key => ({ type: FILE_REMOVE, key })

export const removeFiles = () => ({ type: FILES_REMOVE })

export const addMessage = message => ({ type: MESSAGE_ADD, message: { ...message, id: uniqueId() } })

export const removeMessage = id => ({ type: MESSAGE_REMOVE, id })

export const setFetching = fetching => ({ type: FETCHING_SET, fetching })

// This is on wrong file because favoriteVideos is saved to global state (as is session)
export const updateFavoriteVideos = (favoriteVideos, context) => ({ type: FAVORITE_VIDEOS_UPDATE, favoriteVideos, context })

export const setEmbedded = value => ({ type: TOGGLE_EMBEDDED, value })

export const addError = (error, context) => (dispatch, getState) => {
  if (config.IS_ERROR_LOGGER_ENABLED) {
    if (error && 'response' in error && [401, 402, 403, 404].indexOf(error.response.status) > -1) {
      console.warn(error)
    } else {
      console.error(error)
    }
  }

  // We don't care forbidden errors
  if ('response' in error && [401, 402, 403, 404].indexOf(error.response.status) > -1) {
    return
  }

  if (typeof Raven !== 'undefined') {
    Raven.captureException(error, {
      extra: context,
    })
  }

  const message = {
    style: 'danger',
    text: languages[getState().global.language].global.generalError,
  }

  return dispatch(addMessage(message))
}
